import React from "react";

import cn from "classnames";
import css from "./Typography.module.css";

type TypographyProps = {
    variant: "headline" | "title" | "subtitle" | "body" | "body-medium" | "label" | "badge";
    color?:
        | "primary"
        | "secondary"
        | "gray1"
        | "gray2"
        | "gray3"
        | "gray4"
        | "status-error"
        | "general-black"
        | "general-white";
    className?: string;
    weight?: "normal" | "semibold" | "bold";
};

export const Typography: React.FC<React.PropsWithChildren<TypographyProps>> = ({
    children,
    className,
    variant = "body",
    color,
    weight = "normal",
}) => {
    return (
        <div
            className={cn(`typography-${variant}`, css.main, css[weight], className)}
            style={{ color: color ? `var(--color-${color})` : undefined }}
        >
            {children}
        </div>
    );
};
